import { z } from "zod";

import { emailSuppressionRemovedSchema, emailSuppressionRowSchema } from "@signalist/shared-types";

import { MetaDataSchema } from "@/schemas/meta-data";

/** One page of the Suppressed tab (`GET contact/suppressions`, PREC-4266). */
export const EmailSuppressionPageSchema = z.object({
	data: z.array(emailSuppressionRowSchema),
	meta: MetaDataSchema,
});

export type EmailSuppressionPage = z.infer<typeof EmailSuppressionPageSchema>;

export { emailSuppressionRemovedSchema as EmailSuppressionRemovedSchema };

export interface EmailSuppressionPageParams {
	page: number;
	limit: number;
	searchValue?: string;
}
